import { ValidationCheck } from '@infomaniak/angular-common/src/components/validation-check/validation-check.model';
import { translate } from '@ngneat/transloco';

export const getPasswordValidationMessage = (passwordValidation: ValidationCheck, minLength = 8) => {
  const errors = [];
  let messages = '';

  if (!passwordValidation.lowerCase) {
    errors.push(translate('Au moins une minuscule'));
  }
  if (!passwordValidation.upperCase) {
    errors.push(translate('Au moins une majuscule'));
  }
  if (!passwordValidation.number) {
    errors.push(translate('Au moins un chiffre'));
  }
  if (!passwordValidation.characterCount) {
    errors.push(translate('$number$ caracteres ou plus', { number: 8 }));
  }

  if (errors.length > 0) {
    messages += translate('Votre mot de passe doit contenir :') + ' ' + errors.join(', ') + '<br>';
  }

  if (!passwordValidation.dontIncludeChar && typeof passwordValidation.dontInclude === 'string') {
    messages += translate('Votre mot de passe ne doit pas contenir les caracteres') +
      ` <strong>${passwordValidation.dontInclude.split('').join(' ')}</strong><br>`;
  }
  if (!passwordValidation.startWithChar) {
    messages = translate('Votre mot de passe ne doit pas commencer par un caractere special');
  }

  return messages;
};
